module.exports = __webpack_public_path__ + "static/media/sexart-318f8772.3f0591ee.jpg";